module.exports = __webpack_public_path__ + "img/mycardpay.a1dca470.png";